import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core/styles'

/**
 * Harmony light-header tab styling shared by ProjectTopTabNav and StudioTopTabNav —
 * plain text with an underline accent on the active tab, not filled pill buttons.
 * Apply exactly one of dark or light classes per slot, never both.
 */
/** Height of the Harmony tab row, in pixels. */
export const HARMONY_TAB_HEIGHT = 36

export const useHarmonyTabStyles = makeStyles((theme: Theme) => ({
    tabButtonLight: {
        ...theme.harmony.typography.tabLabel,
        // !important: MUI's own .MuiButtonBase-root/.MuiButton-text compound-class selectors
        // outrank this single custom class on specificity for height/padding otherwise.
        height: `${pxToRem(HARMONY_TAB_HEIGHT)} !important`,
        padding: `0 ${theme.harmony.spacing.md} !important`,
        borderRadius: 0,
        color: theme.harmony.colors.textParagraph,
        border: 'none',
        backgroundColor: 'transparent',
        '&:hover': {
            backgroundColor: 'transparent',
            color: theme.harmony.colors.brandMain,
        },
    },
    activeTabButtonLight: {
        color: theme.harmony.colors.textHeader,
        fontWeight: 600,
        // inset box-shadow draws the underline without affecting layout/height,
        // unlike a real border-bottom.
        boxShadow: `inset 0 -3px 0 0 ${theme.harmony.colors.brandMain}`,
        '&:hover': {
            color: theme.harmony.colors.textHeader,
        },
    },
    disabledTabButtonLight: {
        '& span': {
            opacity: 0.5,
        },
    },
}))
